

export const soraExamples = {
    title: 'Sora 2 视频生成范例 — 强大效果一览',
    sub: '了解 Sora 2 如何将静态图片与文字描述转化为具备先进物理模拟与电影质感的真实视频',
    imageToVideo: '图片转视频 — 为照片赋予动态',
    imageToVideoDesc: '上传任何静态图片，Sora 2 将以自然运动为其注入生命，并保持视觉一致性与物理真实感。图片转视频模式保留原始美感，同时加入顺滑、贴近真实世界物理的动态效果。',
    originalImage: '原始图片',
    generatedVideo: 'Sora 2 生成视频',
    pill: 'Sora 2',
    textToVideo: '文字转视频 — 从文字到电影场景',
    textToVideoDesc: '用文字描述你的构想，Sora 2 将严格遵循你的指示生成专业品质的视频。文字转视频模式理解复杂的提示（包含运动镜头、光线、动作和风格），精准还原你所设想的画面。',
    promptLabel: '文字提示',
    promptText: '「好莱坞风格的分手场景，黄昏时分的宁静郊区街道。三十多岁的男女相对而立，低声但情绪充沛地对话。唇形与分手对白同步。电影级打光、温暖的夕阳色调、浅景深、微风拂动秋叶、真实自然声音，无背景音乐」'
  };
